import { ref } from "vue";

// El navegador solo busca un service worker nuevo al cargar la página, así que
// en pestañas que quedan abiertas horas hay que preguntar a mano.
const CHECK_INTERVAL = 15 * 60 * 1000;

// Estado compartido: lo consume AppUpdateAvailable y lo alimenta
// registerServiceWorker.
const updateAvailable = ref(false);
const updating = ref(false);

// Si la página ya se cargó bajo el control de un service worker, un
// controllerchange posterior significa "versión nueva". Si no lo había, es la
// primera toma de control y no hay nada que avisar.
const hadController =
  "serviceWorker" in navigator && !!navigator.serviceWorker.controller;

let waitingWorker = null;
let reloading = false;
let listeningControllerChange = false;

const reloadOnce = () => {
  if (reloading) return;
  reloading = true;
  window.location.reload();
};

const listenControllerChange = () => {
  if (listeningControllerChange || !("serviceWorker" in navigator)) return;
  listeningControllerChange = true;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // Recargar solo si la actualización la pidió el usuario. Si el control lo
    // tomó un service worker nuevo por su cuenta (o lo activó otra pestaña),
    // avisamos con el banner en vez de recargar y hacerle perder lo que
    // estuviera escribiendo.
    if (updating.value) {
      reloadOnce();
      return;
    }
    if (hadController) updateAvailable.value = true;
  });
};

/**
 * Marca que hay una versión nueva ya descargada y esperando para activarse.
 */
export const markUpdateAvailable = (registration) => {
  waitingWorker = registration.waiting || waitingWorker;
  updateAvailable.value = true;
};

/**
 * Arranca la vigilancia de nuevas versiones para un service worker registrado.
 */
export const startUpdateChecks = (registration) => {
  listenControllerChange();

  // La versión nueva pudo quedar en espera de una visita anterior.
  if (registration.waiting) markUpdateAvailable(registration);

  const check = () => {
    if (updateAvailable.value) return;
    registration.update().catch(() => {});
  };

  setInterval(check, CHECK_INTERVAL);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
  window.addEventListener("online", check);
};

/**
 * Activa la versión nueva y recarga la aplicación.
 */
export const applyUpdate = () => {
  updating.value = true;

  if (!waitingWorker) {
    reloadOnce();
    return;
  }

  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  // Red de seguridad: si el service worker no toma el control (quedó redundante,
  // el mensaje se perdió) recargamos igual para no dejar al usuario atrapado.
  setTimeout(reloadOnce, 3000);
};

export default function useAppUpdate() {
  return { updateAvailable, updating, applyUpdate };
}
